import React from "react";
import { Modal } from "react-bootstrap";
import tableStructure from "./tableStructure";
import { BACKGROUND_COLORS } from "./stylemap";

const paddingValues = [1, 2, 3, 4, 5];
const alignValues = {
  top: "Сверху",
  middle: "Центр",
  bottom: "Внизу",
};

export default class EditorTableDialog extends React.Component {
  constructor(props) {
    super(props);

    let table =
      this.props.currentTable && Array.isArray(this.props.currentTable)
        ? this.props.currentTable
        : false;

    let { row, col } = tableStructure.cellLocate(table, this.props.block.key);
    let cell = table[row][col];

    let data = {};
    let cellPropKeys = Object.keys(tableStructure.cellDefaults());
    cellPropKeys.forEach((prop) => {
      data[prop] = cell[prop];
    });

    this.state = {
      table,
      data,
      row,
      col,
      cell,
      borderPreset: null,
    };
  }
  onHide = () => {
    this.props.onHide();
  };
  onSave = () => {
    this.props.onSave(this.state);
  };
  onChange = (e) => {
    let id = e.target.id;
    let type = e.target.getAttribute("type");
    let value = type === "checkbox" ? e.target.checked : e.target.value;

    let data = this.state.data;

    data[id] = value;
    this.setState({ data, borderPreset: null });
  };

  onChangeColor = (color) => {
    let data = this.state.data;

    data["backgroundColor"] = color;
    this.setState({ data });
  };

  setBorderPreset = (borderPreset) => this.setState({ borderPreset });

  render() {
    return (
      <>
        <Modal show size="lg" dialogClassName="editor-table-dialog" onHide={this.onHide}>
          <Modal.Header closeButton closeLabel="Закрыть">
            <Modal.Title>Ячейка таблицы</Modal.Title>
          </Modal.Header>

          {this.state.table && (
            <Modal.Body>
              <div className="row">
                <div className="col-8 col-lg-5">
                  <h5 className="mb-5">Отступ, положение</h5>
                  <div className="form-group pt-3">
                    <div className="form-group">
                      <label>Отступ внутри:</label>
                      <select
                        value={this.state.data.padding || ""}
                        id="padding"
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value=""></option>
                        {paddingValues.map((padding) => (
                          <option
                            key={padding}
                            value={padding}
                          >{`${padding} пт.`}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Положение по вертикали:</label>
                      <select
                        value={this.state.data.verticalAlign || ""}
                        id="verticalAlign"
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value=""></option>
                        {Object.keys(alignValues).map((verticalAlign) => (
                          <option key={verticalAlign} value={verticalAlign}>
                            {alignValues[verticalAlign]}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-4 col-lg-2">
                  <h5 className="mb-5">Заливка</h5>
                  <div className="form-group pt-3">
                    {BACKGROUND_COLORS.map((color) => (
                      <button
                        key={color}
                        title={`Заливка ячейки: ${color}`}
                        aria-label={`Заливка ячейки: ${color}`}
                        onClick={() => this.onChangeColor(color)}
                        className={`btn ml-1 mt-1 btn-icon ${
                          this.state.data.backgroundColor === color
                            ? "btn-secondary"
                            : "btn-light"
                        }`}
                      >
                        <div
                          className="color-box"
                          style={{ background: color }}
                        ></div>
                      </button>
                    ))}
                  </div>
                </div>
                <div className="col-12 col-lg-5 table-settings-borders">
                  <h5 className="mb-5">Границы</h5>
                  <p className="text-muted small">
                    Применяются к выделенным ячейкам. Как в Word, выберите готовый
                    вариант или настройте стороны вручную.
                  </p>
                  <div className="table-border-presets" role="group" aria-label="Видимость границ">
                    {[
                      ["all", "Все границы", "▦"],
                      ["none", "Нет границ", "□"],
                      ["outer", "Внешние границы", "▣"],
                      ["inner", "Внутренние границы", "⊞"],
                      ["inner-horizontal", "Внутренние горизонтальные", "☷"],
                      ["inner-vertical", "Внутренние вертикальные", "▥"],
                    ].map(([id, label, icon]) => (
                      <button
                        key={id}
                        type="button"
                        title={label}
                        aria-label={label}
                        aria-pressed={this.state.borderPreset === id}
                        className={`btn btn-light table-border-presets__button ${
                          this.state.borderPreset === id ? "is-active" : ""
                        }`}
                        onClick={() => this.setBorderPreset(id)}
                      >
                        <span aria-hidden="true">{icon}</span>
                        <span>{label}</span>
                      </button>
                    ))}
                  </div>
                  <hr />
                  <p className="text-muted small mb-2">Ручная настройка сторон</p>
                  <div className="form-group pt-3">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderLeft"
                        onChange={this.onChange}
                        checked={this.state.data.borderLeft}
                      />
                      <span className="mr-2"></span>
                      Слева
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderRight"
                        onChange={this.onChange}
                        checked={this.state.data.borderRight}
                      />
                      <span className="mr-2"></span>
                      Справа
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderTop"
                        onChange={this.onChange}
                        checked={this.state.data.borderTop}
                      />
                      <span className="mr-2"></span>
                      Сверху
                    </label>
                  </div>
                  <div className="form-group">
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        id="borderBottom"
                        onChange={this.onChange}
                        checked={this.state.data.borderBottom}
                      />
                      <span className="mr-2"></span>
                      Снизу
                    </label>
                  </div>
                </div>
              </div>
            </Modal.Body>
          )}

          <Modal.Footer>
            <button title="Сохранить параметры ячейки" onClick={this.onSave} className="btn btn-primary">
              Сохранить
            </button>
            <button title="Закрыть без сохранения" onClick={this.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
